import { plotWidth } from "./state";
import { getTheme } from "./theme";
import type { PriceLabel, State, TimeLabel } from "./types";

export function drawTimeLabels(ctx: CanvasRenderingContext2D, state: State, timeLabels: TimeLabel[]): void {
  ctx.save();
  ctx.textAlign = "center";
  ctx.textBaseline = "top";
  ctx.font = "500 12px 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
  ctx.fillStyle = getTheme(state).text;

  const plotLeft = state.left;
  const plotRight = state.left + plotWidth(state);
  const labelY = state.height - state.bottom + 6;

  for (const label of timeLabels) {
    const halfWidth = ctx.measureText(label.label).width / 2;
    if (label.x - halfWidth < plotLeft) continue;
    if (label.x + halfWidth > plotRight) continue;
    ctx.fillText(label.label, label.x, labelY);
  }
  ctx.restore();
}

export function drawPriceLabels(ctx: CanvasRenderingContext2D, state: State, priceLabels: PriceLabel[]): void {
  if (!state.displaySettings.showPriceAxis) return;
  if (!priceLabels || priceLabels.length === 0) return;
  
  // ===== GET PRECISION FROM THE DATA (FORCE IT) =====
  const latestTick = state.chartData[state.chartData.length - 1];
  const pip = latestTick?.precision ?? latestTick?.pip_size ?? 2;
  
  ctx.save();
  ctx.fillStyle = getTheme(state).text;
  ctx.font = "500 12px 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
  ctx.textBaseline = "middle";

  const fontPx = 12;
  const halfH = fontPx / 2;
  const topBound = state.top;
  const bottomBound = state.top + (state.height - state.top - state.bottom);
  const plotW = plotWidth(state);
  
  const pricePosition = state.pricePosition || "right";

  // Left side labels - INSIDE the chart
  if (pricePosition === "left" || pricePosition === "both") {
    ctx.textAlign = "left";
    const labelX = state.left + 6;
    for (const label of priceLabels) {
      if (label.y - halfH < topBound) continue;
      if (label.y + halfH > bottomBound) continue;
      // ===== FORCE PRECISION =====
      ctx.fillText(label.value.toFixed(pip), labelX, label.y);
    }
  }
  
  // Right side labels - OUTSIDE the chart
  if (pricePosition === "right" || pricePosition === "both") {
    ctx.textAlign = "left";
    const labelX = state.left + plotW + 6;
    for (const label of priceLabels) {
      if (label.y - halfH < topBound) continue;
      if (label.y + halfH > bottomBound) continue;
      // ===== FORCE PRECISION =====
      ctx.fillText(label.value.toFixed(pip), labelX, label.y);
    }
  }
  
  ctx.restore();
}
